module.exports = __webpack_public_path__ + "c0be201babcb7158717666a52be4d1b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/snow.jpg
// module id = 175
// module chunks = 0